/**
 * Application entry point
 */
import './amplify-config';
import '@codespeak11/bdance-theme/css';

import { AuthProvider, useAuth } from '@codespeak11/cognito-passwordless';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { theme } from './theme';
import { installSignedOutGuard } from './auth/signOut';
import { registerValidTokenGetter } from './services/authBridge';

installSignedOutGuard();

/**
 * Bridges the library's hook-only `getValidToken` (which refreshes the SSO
 * session when needed) to the non-React axios interceptors via authBridge.
 * Without this, an expired access token forces a hard logout mid-session.
 */
function AuthBridge() {
  const { getValidToken } = useAuth();
  useEffect(() => {
    registerValidTokenGetter(getValidToken);
    return () => registerValidTokenGetter(null);
  }, [getValidToken]);
  return null;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <AuthBridge />
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
